import { createAction } from 'redux-actions';

export const LOGIN = 'LOGIN';
export const login = createAction(LOGIN);

export const PHONE_LOGIN = 'PHONE_LOGIN';
export const phoneLogin = createAction(PHONE_LOGIN);

export const PHONE_REGISTER = 'PHONE_REGISTER';
export const phoneRegister = createAction(PHONE_REGISTER);

export const SIGN_UP = 'SIGN_UP';
export const signUp = createAction(SIGN_UP);

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const changePassword = createAction(CHANGE_PASSWORD);

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const loginSuccess = createAction(LOGIN_SUCCESS);

export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const signUpSuccess = createAction(SIGN_UP_SUCCESS);

export const UPDATE_SCREEN_NAME = 'UPDATE_SCREEN_NAME';
export const updateScreenName = createAction(UPDATE_SCREEN_NAME);

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const updateUserInfo = createAction(UPDATE_USER_INFO);

export const LOGOUT = 'LOGOUT';
export const logout = createAction(LOGOUT);

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const logoutSuccess = createAction(LOGOUT_SUCCESS);

export const SOCIAL_LOGIN = 'SOCIAL_LOGIN';
export const socialLogin = createAction(SOCIAL_LOGIN);

export const GET_USER_PROFILE_DETAILS = 'GET_USER_PROFILE_DETAILS';
export const getUserProfileDetails = createAction(GET_USER_PROFILE_DETAILS);

export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const editUserProfile = createAction(EDIT_USER_PROFILE);

export const GET_USER_PASSWORD = 'GET_USER_PASSWORD';
export const getUserPassword = createAction(GET_USER_PASSWORD);

export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const updateUserPassword = createAction(UPDATE_USER_PASSWORD);

export const GET_ADDRESSES = 'GET_ADDRESSES';
export const getAddresses = createAction(GET_ADDRESSES);

export const ADD_ADDRESS = 'ADD_ADDRESS';
export const addAddress = createAction(ADD_ADDRESS);

export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const deleteAddress = createAction(DELETE_ADDRESS);

export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const updateAddress = createAction(UPDATE_ADDRESS);

export const UPDATE_ADDRESS_INFO = 'UPDATE_ADDRESS_INFO';
export const updateAddressInfo = createAction(UPDATE_ADDRESS_INFO);

export const TOGGLE_DEFAULT_ADDRESS = 'TOGGLE_DEFAULT_ADDRESS';
export const toggleDefaultAddress = createAction(TOGGLE_DEFAULT_ADDRESS);

export const TOGGLE_DEFAULT_PHONE = 'TOGGLE_DEFAULT_PHONE';
export const toggleDefaultPhone = createAction(TOGGLE_DEFAULT_PHONE);

export const TOGGLE_DEFAULT_EMAIL = 'TOGGLE_DEFAULT_EMAIL';
export const toggleDefaultEmail = createAction(TOGGLE_DEFAULT_EMAIL);

export const TOGGLE_DEFAULT_BANK = 'TOGGLE_DEFAULT_BANK';
export const toggleDefaultBank = createAction(TOGGLE_DEFAULT_BANK);

export const DELETE_EMAIL = 'DELETE_EMAIL';
export const deleteEmail = createAction(DELETE_EMAIL);

export const DELETE_PHONE = 'DELETE_PHONE';
export const deletePhone = createAction(DELETE_PHONE);

export const DELETE_BANK = 'DELETE_BANK';
export const deleteBank = createAction(DELETE_BANK);

export const DELETE_PAN = 'DELETE_PAN';
export const deletePan = createAction(DELETE_PAN);

export const USER_PLAYING_HISTORY = 'USER_PLAYING_HISTORY';
export const getPlayingHistory = createAction(USER_PLAYING_HISTORY);

export const GET_PAN_DETAILS = 'GET_PAN_DETAILS';
export const getPAN_Details = createAction(GET_PAN_DETAILS);

export const UPDATE_PAN_DETAILS = 'UPDATE_PAN_DETAILS';
export const updatePan = createAction(UPDATE_PAN_DETAILS);

export const GET_BANK_DETAILS = 'GET_BANK_DETAILS';
export const getBankDetails = createAction(GET_BANK_DETAILS);

export const UPDATE_BANK_DETAILS = 'UPDATE_BANK_DETAILS';
export const updateBank = createAction(UPDATE_BANK_DETAILS);

export const GET_PHONE_DETAILS = 'GET_PHONE_DETAILS';
export const getPhoneDetails = createAction(GET_PHONE_DETAILS);

export const UPDATE_PHONE_DETAILS = 'UPDATE_PHONE_DETAILS';
export const updatePhone = createAction(UPDATE_PHONE_DETAILS);

export const GET_EMAIL_DETAILS = 'GET_EMAIL_DETAILS';
export const getEmailDetails = createAction(GET_EMAIL_DETAILS);

export const UPDATE_EMAIL_DETAILS = 'UPDATE_EMAIL_DETAILS';
export const updateEmail = createAction(UPDATE_EMAIL_DETAILS);

export const VERIFY_PAN = 'VERIFY_PAN';
export const verifyPAN = createAction(VERIFY_PAN);

export const VERIFY_BANK_DETAILS = 'VERIFY_BANK_DETAILS';
export const verifyBankDetails = createAction(VERIFY_BANK_DETAILS);

export const SEND_MOBILE_OTP = 'SEND_MOBILE_OTP';
export const sendMobileOTP = createAction(SEND_MOBILE_OTP);

export const VERIFY_MOBILE_OTP = 'VERIFY_MOBILE_OTP';
export const verifyMobileOTP = createAction(VERIFY_MOBILE_OTP);

export const SEND_EMAIL_OTP = 'SEND_EMAIL_OTP';
export const sendEmailOTP = createAction(SEND_EMAIL_OTP);

export const VERIFY_EMAIL_OTP = 'VERIFY_EMAIL_OTP';
export const verifyEmailOTP = createAction(VERIFY_EMAIL_OTP);

export const RESET_PASSWORD_SEND_EMAIL = 'RESET_PASSWORD_SEND_EMAIL';
export const resetPasswordSendEmail = createAction(RESET_PASSWORD_SEND_EMAIL);

export const RESET_PASSWORD_VERIFY_EMAIL = 'RESET_PASSWORD_VERIFY_EMAIL';
export const resetPasswordVerifyEmail = createAction(RESET_PASSWORD_VERIFY_EMAIL);

export const ADDRESS_STATUS = 'ADDRESS_STATUS';
export const setAddressStatus = createAction(ADDRESS_STATUS);

export const ADD_EMAIL = 'ADD_EMAIL';
export const addEmail = createAction(ADD_EMAIL);

export const UPDATE_GAME_TYPE = 'UPDATE_GAME_TYPE';
export const updateGameType = createAction(UPDATE_GAME_TYPE);

export const UPDATE_SUBSCRIBED_MATCH_LIST = 'UPDATE_SUBSCRIBED_MATCH_LIST';
export const updateSubscribedMatchList = createAction(UPDATE_SUBSCRIBED_MATCH_LIST);

export const GENERATE_REFERRAL_LINK = 'GENERATE_REFERRAL_LINK';
export const generateReferralLink = createAction(GENERATE_REFERRAL_LINK);

export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';
export const updateUserName = createAction(UPDATE_USER_NAME);

export const SET_USER_NAME = 'SET_USER_NAME';
export const setUserName = createAction(SET_USER_NAME);

export const GET_REVENUE_ANALYTICS_REFERRAL = 'GET_REVENUE_ANALYTICS_REFERRAL';
export const getRevenueAnalyticsReferral = createAction(GET_REVENUE_ANALYTICS_REFERRAL);

export const GET_REVENUE_ANALYTICS_AFFILIATE = 'GET_REVENUE_ANALYTICS_AFFILIATE';
export const getRevenueAnalyticsAffiliate = createAction(GET_REVENUE_ANALYTICS_AFFILIATE);

export const GET_USER_ANALYTICS_REFERRAL = 'GET_USER_ANALYTICS_REFERRAL';
export const getUserAnalyticsReferral = createAction(GET_USER_ANALYTICS_REFERRAL);

export const GET_USER_ANALYTICS_AFFILIATE = 'GET_USER_ANALYTICS_AFFILIATE';
export const getUserAnalyticsAffiliate = createAction(GET_USER_ANALYTICS_AFFILIATE);

export const SET_EMAIL_VERIFY_COUNT_DATA = 'SET_EMAIL_VERIFY_COUNT_DATA';
export const setEmailVerifyCountData = createAction(SET_EMAIL_VERIFY_COUNT_DATA);

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const updateUserData = createAction(UPDATE_USER_DATA);

export const GET_FEEDBACK_FORM = 'GET_FEEDBACK_FORM';
export const getFeedbackForm = createAction(GET_FEEDBACK_FORM);

export const POST_FEEDBACK_FORM = 'POST_FEEDBACK_FORM';
export const postFeedbackForm = createAction(POST_FEEDBACK_FORM);

export const SET_WALLET_BALLANCE = 'SET_WALLET_BALLANCE';
export const setWalletBallance = createAction(SET_WALLET_BALLANCE);

export const SET_AVATAR = 'SET_AVATAR';
export const setAvatar = createAction(SET_AVATAR);

export const SET_OPPONENT_USER = 'SET_OPPONENT_USER';
export const setOpponentUserDetail = createAction(SET_OPPONENT_USER);

export const UPDATE_USER_LEVEL = 'UPDATE_USER_LEVEL';
export const updateUserLevel = createAction(UPDATE_USER_LEVEL);

export const SET_ISLOGIN = 'SET_ISLOGIN';
export const setIsLogin = createAction(SET_ISLOGIN);

export const SET_ISSIGNUP = 'SET_ISSIGNUP';
export const setIsSignUp = createAction(SET_ISSIGNUP);

export const SIGNIN_WITH_MOBILE = 'SIGNIN_WITH_MOBILE';
export const signInWithMobile = createAction(SIGNIN_WITH_MOBILE);

export const SET__USER__LOGIN__MODAL = 'SET__USER__LOGIN__MODAL';
export const setUserLoginModal = createAction(SET__USER__LOGIN__MODAL);

export const USER_LOGOUT = 'USER_LOGOUT';
export const userLogOut = createAction(USER_LOGOUT);

export const RESET_SIGNIN_MODES = 'RESET_SIGNIN_MODES';
export const resetSigninModes = createAction(RESET_SIGNIN_MODES);

export const SET_IS_SPIN_THE_WHEEL = 'SET_IS_SPIN_THE_WHEEL';
export const setIsSpinTheWheel = createAction(SET_IS_SPIN_THE_WHEEL);

export const SET_IS_DRAWER_OPEN = 'SET_IS_DRAWER_OPEN';
export const setIsDrawerOpen = createAction(SET_IS_DRAWER_OPEN);
